import { render } from "./TimeTableRating.vue?vue&type=template&id=9e96d9f4"
import script from "./TimeTableRating.vue?vue&type=script&lang=js"
export * from "./TimeTableRating.vue?vue&type=script&lang=js"

import "./TimeTableRating.vue?vue&type=style&index=0&id=9e96d9f4&lang=css"

import exportComponent from "C:\\Users\\antho\\OneDrive\\Desktop\\Trans-IDP-Login\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__